const map_errors = error => {
    let errors_Class = [
        { type : "alert-success", val : "success" },
        { type : "alert-info", val : "info" },
        { type : "alert-danger", val : "danger" },
        { type : "error", val : "danger" },
    ];

    let err = errors_Class.filter(c => c.type === error || c.val === error)[0]

    if(err) return err["val"]
    
    return "success";
}


export default function (state = [], action) {

    return new Promise((resolve, reject) =>{

        switch (action.type) {
            case 'NOTIFY':
                let errors = action.payload;
                //eslint-disable-next-line
                errors.map(e => {
                    window.notify({
                        title: e.title,
                        message: e.message || e.msg,
                    }, {
                        type: map_errors(e.type) // success, danger, warning
                    });
    
                })
                
                resolve(action.payload)
                break;
    
    
            default:
                resolve(state)
                break;
        }

    })




}